import { alpha } from '@mui/material/styles';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

// ----------------------------------------------------------------------

export function overrides(theme, state) {
    const setting = state.setting;
    return {
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    boxSizing: 'border-box',
                },
                html: {
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    height: '100%',
                    WebkitOverflowScrolling: 'touch',
                },
                body: {
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    height: '100%',
                },
                '#root': {
                    width: '100%',
                    height: '100%',
                },
                input: {
                    '&[type=number]': {
                        MozAppearance: 'textfield',
                        '&::-webkit-outer-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                        '&::-webkit-inner-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                    },
                },
                img: {
                    maxWidth: '100%',
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: alpha(theme.palette.grey[900], 0.8),
                },
                invisible: {
                    background: 'transparent',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                containedInherit: {
                    color: theme.palette.common.white,
                    backgroundColor: theme.palette.grey[800],
                    '&:hover': {
                        color: theme.palette.common.white,
                        backgroundColor: theme.palette.grey[800],
                    },
                },
                sizeLarge: {
                    minHeight: 48,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: theme.customShadows.card,
                    borderRadius: Number(theme.shape.borderRadius) * 2,
                    position: 'relative',
                    zIndex: 0, // Fix Safari overflow: hidden with border radius
                },
            },
        },
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: { variant: 'h6' },
                subheaderTypographyProps: { variant: 'body2' },
            },
            styleOverrides: {
                root: {
                    padding: theme.spacing(3, 3, 0),
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.common.white,
                    fontSize: '14px',
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    label: {
                        fontSize: '14px',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    label: {
                        fontSize: '14px',
                    },
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    [`& .${outlinedInputClasses.notchedOutline}`]: {
                        // borderColor: alpha(theme.palette.grey[500], 0.24),
                    },
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    // border: `1px solid #d2e4d6`,
                    '&.slim-pd td': {
                        padding: '10px',
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    th: {
                        backgroundColor: theme.palette.primary.dark,
                        color: theme.palette.common.white,
                        height: '47px',
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    // backgroundColor: theme.palette.primary.dark,
                    // color:""
                    backgroundColor: theme.palette.primary.dark,
                    color: theme.palette.common.white,
                    // height:"47px",
                    // minHeight:"60px"
                },
                root: {
                    // backgroundColor: theme.palette.primary.dark,

                    borderBottom: `1px solid ${theme.palette.grey[300]}`,
                    padding: '5px',
                    fontSize: '13px',
                    textAlign: 'center',
                    height: '53px',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    display: setting.guide ? 'block' : 'none',
                },
                arrow: {},
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    '&.MuiTypography-h4': {
                        margin: '18px 0px',
                    },
                    '&.MuiTypography-h5': {
                        margin: '12px 0px',
                    },
                },
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.grey[300],
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    ...theme.typography.body2,
                },
            },
        },
    };
}
